import { useContext } from "react";
import { Context } from "../../context/ContextApp";
import { IPaymentDetails } from "../../interfaces/interfaces";
import { IPaymentDetailOptions } from "./paymentIntent";

interface IProps {
  options: IPaymentDetailOptions | null;
  paymentDetails: IPaymentDetails | null;
}

const PaymentDetails = (props: IProps) => {
  const { options, paymentDetails } = props;
  const { appBranch } = useContext(Context);
  const defaultOption = options?.national;

  return (
    <div className="payment-details">
      {defaultOption && (
        <div>
          <div className="details-row">
            <div>Items(s) Subtotal:</div>
            <div>${defaultOption.total_products?.toFixed(2) ?? "0.00"}</div>
          </div>
          <div className="details-row">
            <span>Delivery:</span>
            <span>${defaultOption.shipping_cost?.toFixed(2) ?? "0.00"}</span>
          </div>
          <div className="details-row">
            <span>GST:</span>
            <span>${defaultOption.tax?.toFixed(2) ?? "0.00"}</span>
          </div>
          <div className="details-row bold">
            <span>Subtotal:</span>
            <span>${defaultOption.subtotal?.toFixed(2) ?? "0.00"}</span>
          </div>

          {appBranch !== "au" && (
            <div className="details-row">
              <span>Merchant Service Fee (MSF):</span>
              <span>
                {paymentDetails?.transaction_fee
                  ? `$${paymentDetails.transaction_fee.toFixed(2)}`
                  : "PENDING"}
              </span>
            </div>
          )}
          <div className="details-row bold">
            <span>Grand total:</span>
            <span>
              {paymentDetails?.grand_total
                ? `$${paymentDetails.grand_total.toFixed(2)}`
                : "PENDING"}
            </span>
          </div>
        </div>
      )}
      {!paymentDetails && (
        <p className="description">MSF is calculated and added when card number is entered</p>
      )}
    </div>
  );
};

export default PaymentDetails;
